import { useEffect, useRef, useState } from 'react'
import { type DraftHost, onHostPublishRequest } from '~/entities/profile/model/host-publish'
import * as m from '~/paraglide/messages'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~/shared/ui/alert-dialog'

/** Asks whether a draft profile goes public along with the event it hosts. */
export function HostPublishHost() {
  const [host, setHost] = useState<DraftHost | null>(null)
  const answerRef = useRef<((publish: boolean) => void) | null>(null)

  useEffect(
    () =>
      onHostPublishRequest(
        (next) =>
          new Promise((resolve) => {
            answerRef.current = resolve
            setHost(next)
          }),
      ),
    [],
  )

  const answer = (publish: boolean) => {
    answerRef.current?.(publish)
    answerRef.current = null
    setHost(null)
  }

  return (
    <AlertDialog
      open={host !== null}
      onOpenChange={(open) => {
        if (!open) answer(false)
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.hostPublishTitle()}</AlertDialogTitle>
          <AlertDialogDescription>
            {m.hostPublishDescription({ name: host?.name ?? '' })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel()}</AlertDialogCancel>
          <AlertDialogAction onClick={() => answer(true)}>
            {m.hostPublishConfirm()}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
